/** @format */

import HeaderSubtext from './HeaderSubtext';

export default HeaderSubtext;
